import type { FaireProductEntity } from "../../entity_types/product";

export const p_3s7sxweba3: FaireProductEntity = {
  token: "p_3s7sxweba3",
  type: "product",
  name: "Bird Nerd Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a6cf684a2b3797ac36639807e494a664ef36d0289900d3cee6966e29eae9d455.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cadf2c76723a774febafc1566c528507ea90ca1636963f7e547690ffd0f3b0d3.jpeg",
    "https://cdn.faire.com/fastly/755f6db5750beff8586de55662ef9b69c8f4f1886005b0d05b22b87a27796dab.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/9b75673a6cf3af639a8c649fb6a462c9ea6c9e58e12c6e75c355303fcf2823bd.jpeg",
    "https://cdn.faire.com/fastly/0e342fd125d82a0e3be1ed89e342230d7db059255bdb12f94fbbb430f4b40130.jpeg"
  ],
  priceDollars: 6.75,
  description: "Geek out and freak out on all things that squawk! Get some socks that match your bird nerd energy and let your feathered friends know they have a fan. 🤓\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:53.336Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
